import { FormattedMessage } from 'react-intl';
import AdhesionContract from '@/common/documents/adhesion_agreement_Legal_Money.pdf';
import License from '@/common/documents/license.pdf';
import AccidentInsurance from '@/common/documents/neocredit_pravila_dobrovolnogo_onlajn_strahovanija_ot_neschastnogo_sluchaja.pdf';
import LifeInsuranceTermsConditions from '@/common/documents/neocredit_pravila_dobrovolnogo_onlajn_strahovanija_zhizni.pdf';
import DebtDisposalProcedure from '@/common/documents/neocredit_uregulirovanie_zadolzhennosti.pdf';
import PrivacyPolicy from '@/common/documents/privacy_policy.pdf';
import LifeInsuranceApplication from '@/common/documents/Заявление_на_страхование.pdf';
import StatementOfAdherence from '@/common/documents/Заявление_о_присоединении_к_договору_Legal_Money.pdf';
import RulesGrantingOnlineLoans from '@/common/documents/Правила_предоставления_микрокредита_электронным_способом.pdf';
import { DocumentProps } from '@/common/types/documents';

export const commonDocuments: DocumentProps[] = [
  {
    name: (
      <FormattedMessage defaultMessage="Договор о предоставлении микрокредита" />
    ),
    url: AdhesionContract,
  },
  {
    name: (
      <FormattedMessage defaultMessage="Заявление о присоединении к договору о предоставлении микрокредита" />
    ),
    url: StatementOfAdherence,
  },
  {
    name: (
      <FormattedMessage defaultMessage="Правила предоставления микрокредитов электронным способом" />
    ),
    url: RulesGrantingOnlineLoans,
  },
  {
    name: (
      <FormattedMessage defaultMessage="Правила добровольного онлайн страхования от несчастного случая" />
    ),
    url: AccidentInsurance,
  },
  {
    name: (
      <FormattedMessage defaultMessage="Правила добровольного онлайн страхования жизни" />
    ),
    url: LifeInsuranceTermsConditions,
  },
  {
    name: (
      <FormattedMessage defaultMessage="Заявление на добровольное онлайн страхование жизни" />
    ),
    url: LifeInsuranceApplication,
  },
  {
    name: (
      <FormattedMessage defaultMessage="Лицензия на осуществление микрофинансовой деятельности" />
    ),
    url: License,
  },

  {
    name: (
      <FormattedMessage defaultMessage="Порядок урегулирования просроченной задолженности" />
    ),
    url: DebtDisposalProcedure,
  },
  {
    name: (
      <FormattedMessage defaultMessage="Политика конфиденциальности и обработка персональных данных" />
    ),
    url: PrivacyPolicy,
  },
];
